export default function AboutSection() {
  return (
    <section className="w-full px-6 md:px-10 lg:px-20 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-20">
          {/* Image column */}
          <div className="w-full lg:w-[48%] relative">
            {/* decorative elements */}
            <svg className="absolute -top-4 -left-4 w-16 h-16 opacity-20 pointer-events-none" viewBox="0 0 80 80">
              <circle cx="40" cy="40" r="34" fill="none" stroke="#7c3aed" strokeWidth="2" strokeDasharray="5 6"/>
            </svg>
            <svg className="absolute bottom-4 -right-4 w-12 h-12 opacity-15 pointer-events-none" viewBox="0 0 60 60">
              <polygon points="30,6 54,50 6,50" fill="none" stroke="#c74461" strokeWidth="2"/>
            </svg>
            <svg className="absolute top-1/2 -right-6 w-10 h-10 opacity-15 pointer-events-none" viewBox="0 0 60 60">
              <path d="M8,50 Q20,20 40,35 T52,8" fill="none" stroke="#1bb0ce" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <img
                          src="/images/h1.jpg"
              alt="NW Trucking of NC team"
              className="w-full h-auto rounded-xl object-cover"
              width={900}
              height={506}
            />
          </div>

          {/* Text column */}
          <div className="w-full lg:w-[52%] space-y-5">
            <p className="text-[11px] font-semibold tracking-[0.35em] text-foreground-400 uppercase">
              ABOUT US
            </p>
            <h2 className="text-[1.75rem] md:text-[2rem] lg:text-[2.4rem] font-extrabold text-foreground-900 leading-tight">
              Few words{" "}
              <span className="text-accent-500">about our company</span>
            </h2>
            <p className="text-[0.9rem] text-foreground-500 leading-relaxed">
              Founded in 2020 and being in business since can tell you something
              about the quality of our services. NW Trucking of NC
              is a name for a reliable local moving company. Ranging from
              residential moving, apartment, storage and commercial moving – we also
              offer professional packing assistance that you can always request
              from us – and we will always deliver.
            </p>
            <div className="pt-2">
              <a
                href="/about-us"
                className="inline-block px-8 py-2.5 bg-accent-500 text-white font-semibold text-sm rounded-full hover:bg-accent-600 transition-colors whitespace-nowrap"
              >
                Read More
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}